import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsBrowserMode: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    description: {
        fontSize: textSizes.mini,
        ...grid.mt_mini,
    },
    radioButtons: {
        ...grid.row,
        ...grid.mt_md,
        ...grid.mb_md,
        width: '40%',
    },
    radio: {
        ...grid.mr_md,
        ...grid.pb_mini,
    },
    checkboxWrapper: {
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        marginTop: 14,
    },
    labelClassName: {
        fontSize: 14,
    },
}

addStyles(deviceSettingsBrowserMode)
export default deviceSettingsBrowserMode
